export const getBuyLink = (inputCurrency: string, outputCurrency: string) => `https://app.uniswap.org/#/swap&inputCurrency=${inputCurrency}&outputCurrency=${outputCurrency}`;
